import { render, staticRenderFns } from "./chooseImg.vue?vue&type=template&id=1fa0545c&scoped=true"
import script from "./chooseImg.vue?vue&type=script&lang=js"
export * from "./chooseImg.vue?vue&type=script&lang=js"
import style0 from "./chooseImg.vue?vue&type=style&index=0&id=1fa0545c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa0545c",
  null
  
)

export default component.exports